import API from './API.ts'

// REVIEW: ta bort fil, flytta till andra services

export default {
  //
  // GET
  //
  getStripeOnboardingLink () {
    return API.httpClient.get('onboarding/stripe-onboarding-link')
  },
  getStripeOnboardingDetails () {
    return API.httpClient.get('onboarding/stripe-onboarding-details')
  },
  getSurfboardOnboardingLink () {
    return API.httpClient.get('onboarding/surfboard-onboarding-link')
  },
  getSurfboardOnboardingDetails () {
    return API.httpClient.get('onboarding/surfboard-onboarding-details')
  },
  resetSurfboardOnboarding () {
    return API.httpClient.post('onboarding/reset-surfboard-onboarding')
  },
  getIcons () {
    return API.httpClient.get('onboarding/icons')
  },
  getCheckinConfirmationPrintSections () {
    return API.httpClient.get('onboarding/checkin-confirmation-print-sections')
  },
  translateText ({ text, toEnglish, toGerman }) {
    return API.httpClient.get('onboarding/translate', {
      params: {
        text,
        to_english: toEnglish,
        to_german: toGerman
      }
    })
  },

  //
  // POST
  //
  savePositions (positions) {
    const items = positions.map((position) => {
      const item = Object.assign({}, position)
      item.category = null
      return item
    })
    return API.httpClient.post('onboarding/save-positions', {
      positions: items
    })
  },
  updateSendCheckinEmailAt ({ categoryId, sendCheckinEmailAt }) {
    return API.httpClient.post('onboarding/update-send-checkin-email-at', {
      category_id: categoryId,
      send_checkin_email_at: sendCheckinEmailAt
    })
  },
  updateSelfCheckinPositions ({ positionIds }) {
    return API.httpClient.post('onboarding/update-self-checkin-positions', {
      position_ids: positionIds
    })
  },
  updateCategoryColor ({ categoryId, color }) {
    return API.httpClient.post('onboarding/update-category-color', {
      category_id: categoryId,
      color
    })
  },
  updateCategoryLodgingTypes ({ categoryId, lodgingTypeIds, defaultLodgingTypeId }) {
    return API.httpClient.post('onboarding/update-category-lodging-types', {
      category_id: categoryId,
      lodging_type_ids: lodgingTypeIds,
      default_lodging_type_id: defaultLodgingTypeId
    })
  },
  updateCategoryGuestCapacity ({ categoryId, maxGuests, maxAdults, maxChildren }) {
    return API.httpClient.post('onboarding/update-category-guest-capacity', {
      category_id: categoryId,
      max_guests: maxGuests,
      max_adults: maxAdults,
      max_children: maxChildren
    })
  },
  updateCategoryDescription ({ categoryId, descriptionSv, descriptionEn, descriptionDe }) {
    return API.httpClient.post('onboarding/update-category-description', {
      category_id: categoryId,
      category_description_sv: descriptionSv,
      category_description_en: descriptionEn,
      category_description_de: descriptionDe
    })
  },
  updateCategoryShowMap ({ categoryId, showMapBooking, showMapSelfCheckin }) {
    return API.httpClient.post('onboarding/update-category-show-map', {
      category_id: categoryId,
      show_map_booking: showMapBooking,
      show_map_self_checkin: showMapSelfCheckin
    })
  },
  updateCategoryBookingCutoffOffset ({ categoryId, bookingCutoffOffset }) {
    return API.httpClient.post('onboarding/update-category-booking-cutoff-offset', {
      category_id: categoryId,
      booking_cutoff_offset: bookingCutoffOffset
    })
  },
  saveCheckinConfirmationPrintSection ({ customInformationId, section }) {
    return API.httpClient.post('onboarding/save-checkin-confirmation-print-sections', {
      custom_information_id: customInformationId,
      ...section
    })
  },
  deleteCheckinConfirmationPrintSection (customInformationId) {
    return API.httpClient.post('onboarding/delete-checkin-confirmation-print-sections', {
      custom_information_id: customInformationId
    })
  },
  reorderCheckinConfirmationPrintSections (sectionIds) {
    return API.httpClient.post('onboarding/reorder-checkin-confirmation-print-sections', {
      section_ids: sectionIds
    })
  }
}
